module.exports = __webpack_public_path__ + "img/c_02.7cf9c4a0.jpg";